module.exports = {"quoting_delivery":"/quoting","quoting_moving_service":"/quoting","quoting_transport":"/quoting","quoting_big_cargo":"/quoting","quoting_extra":"/business"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/default/setting/service/link.json
// module id = 509
// module chunks = 0 1 2 3 4 5